export default "__VITE_ASSET__COitz1Id__"